"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SkriptObject_1 = require("./objects/SkriptObject");
function skript_reader(script) {
    script = script.replace(/\r/g, "");
    return new SkriptObject_1.SkriptObject(script, "body", 0, [], {}, false);
}
exports.default = skript_reader;
